(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inquiry-popup"] && !Shopify.designMode) return;
  try {
    // ---- Popup close handlers ----
  (function() {
    function closePopup(popup) {
      popup.removeAttribute('open');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function(e) {
      const closer = e.target.closest('[data-close-inquiry]');
      if (closer) {
        const id = closer.getAttribute('data-close-inquiry');
        const popup = document.getElementById(id);
        if (popup) closePopup(popup);
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.inquiry-popup[open]').forEach(closePopup);
      }
    });

    // Trap focus inside open popup
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      const popup = document.querySelector('.inquiry-popup[open]');
      if (!popup) return;
      const focusable = popup.querySelectorAll(
        'a[href], button:not([disabled]), input:not([type=hidden]), textarea, select, [tabindex]:not([tabindex="-1"])'
      );
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
